var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"items"},_vm._l((_vm.count),function(i){return _c('el-form-item',{key:i,attrs:{"label":`${_vm.label}（第${i}${_vm.unit}）`}},[_vm._v(" "+_vm._s(_vm.value[i - 1])+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }